<template>
  <span>
    <tomador-cadastro tipoEmissao="P" />

    <Dialog header="Listagem Carta de Correção de Nota Fiscal" :visible.sync="showCartaCorrecaoListagem" :modal="true"
      :closable="false">
      <h1 class="titulo-header">
        Listagem Carta de Correção de Nota Fiscal
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="showCartaCorrecaoListagem = false" />
      </h1><br />
      <div class="scrolable-dialog">
        <div id="topoListagem" class="row">
          <div class="col-md-12 mb-3">
            <DataTable :value="cartasCorrecao" :paginator="true" :rows="10" class="p-datatable-responsive"
              :autoLayout="true">
              <Column>
                <template #body="slotProps">
                  <div class="dropdown">
                    <Button class="btn btn-primary" type="button" id="dropdownMenuButton" icon="pi pi-angle-down"
                      data-toggle="dropdown" title="Opções" aria-haspopup="true" aria-expanded="false"></Button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                      <button class="dropdown-item" type="button" :disabled="loading"
                        @click="visualizar(slotProps.data.id)">
                        <span class="pi pi-search mr-2"></span>Imprimir
                      </button>
                      <button class="dropdown-item" type="button" :disabled="loading"
                        @click="cancelarCartaCorrecaoNfse(slotProps.data.id)">
                        <span class="pi pi-times mr-2"></span>Cancelar
                      </button>
                    </div>
                  </div>
                </template>
              </Column>
              <Column field="dataFormatada" header="Data"></Column>
              <Column field="situacaoFormatada" header="Situação"></Column>
            </DataTable>
          </div>
        </div>
      </div>
      <hr />

      <div class="container">
        <div class="row">
          <div>
            <Button @click="novaCarta(notaFiscal)" href="#topoListagem" type="button" label="Nova Carta de Correção"
              class="p-button-primary mr-2 p-button-success" icon="pi pi-plus" :disabled="loading" />
          </div>

          <div>
            <Button @click="ocultarDialogCartaCorrecaoListagem()" type="button" label="Fechar"
              class="p-button-primary mr-2 p-button-danger" icon="pi pi-times" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog header="Carta de Correção de Nota Fiscal" :visible.sync="showCartaCorrecao" :modal="true">
      <h1 class="titulo-header">
        Carta de Correção de Nota Fiscal
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="showCartaCorrecao = false" />
      </h1><br />
      <div >
        <div id="topo" class="row">
          <div class="col-md-12 mb-3">
            <label>Prestador:</label>
            <span class="p-fluid">
              <div class="p-inputgroup">
                <InputText v-model="selectedPessoaPrestador.detail" type="text" disabled />
                <Button @click="editarPrestador()" id="btnEditarPrestador" type="button" label="Editar Dados"
                  icon="pi pi-pencil" title="Editar Dados Prestador" />
              </div>
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 mb-3">
            <label>Tomador:</label>
            <span class="p-fluid">
              <div class="p-inputgroup">
                <InputText v-model="selectedPessoa.detail" type="text" disabled />
                <Button @click="editarTomador()" id="btnEditarTomador" type="button" label="Editar" icon="pi pi-pencil"
                  title="Editar Tomador" :disabled="selectedPessoa.tipo == 'N'" />
              </div>
            </span>
          </div>
        </div>
        <div class="row" v-if="selectedPessoaIntermediario && selectedPessoaIntermediario.detail">
          <div class="col-md-12 mb-3">
            <label>Intermediário:</label>
            <span class="p-fluid">
              <div class="p-inputgroup">
                <InputText v-model="selectedPessoaIntermediario.detail" type="text" disabled />
                <Button @click="editarIntermediario()" id="btnEditarIntermediario" type="button"
                  label="Editar Intermediario" icon="pi pi-pencil" title="Editar Tomador" />
              </div>
            </span>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 mb-3">
            <label for="descServico">Discriminação dos Serviços:</label>
            <span class="p-fluid">
              <textarea v-model="notaFiscal.discriminacaoServico" rows="5" />
            </span>
          </div>
        </div>

        <div class="row" v-if="observacaoClienteNfse">
          <div class="col-md-12 mb-3">
            <label for="descServico">Observação:</label>
            <span class="p-fluid">
              <textarea v-model="notaFiscal.observacao" rows="5" />
            </span>
          </div>
        </div>

        <div class="row">
          <div class="col-md-3 mb-3">
            <label for="descServico">Número RPS:</label>
            <span class="p-fluid">
              <InputText v-model="notaFiscal.rpsNumero" maxlength="20" />
            </span>
          </div>
          <div class="col-md-3 mb-3">
            <label for="descServico">Série RPS:</label>
            <span class="p-fluid">
              <InputText v-model="notaFiscal.rpsSerie" maxlength="5" />
            </span>
          </div>
          <div class="col-md-3 mb-3">
            <label for="descServico">Tipo RPS:</label>
            <span class="p-fluid">
              <InputText v-model="notaFiscal.rpsTipo" maxlength="1" />
            </span>
          </div>
        </div>

        <div class="row">
          <template v-if="notaFiscal.notaAvulsa === 'S'">
            <div class="col-md mb-3">
              <label for="ir">Irrf:</label>
              <span class="p-fluid">
                <money id="ir" name="ir" v-model="notaFiscal.valorIrrf" v-bind="money" class="p-inputtext input-right">
                </money>
              </span>
            </div>
          </template>
          <div class="col-md mb-3">
            <label for="inss">Inss:</label>
            <span class="p-fluid">
              <money id="inss" name="inss" v-model="notaFiscal.valorInss" v-bind="money" class="p-inputtext input-right">
              </money>
            </span>
          </div>
          <template v-if="notaFiscal.notaAvulsa === 'S'">
            <div class="col-md mb-3">
              <label for="ir">Sest:</label>
              <span class="p-fluid">
                <money id="ir" name="ir" v-model="notaFiscal.valorSest" v-bind="money"
                  class="p-inputtext input-right"></money>
              </span>
            </div>
            <div class="col-md mb-3">
              <label for="ir">Senat:</label>
              <span class="p-fluid">
                <money id="ir" name="ir" v-model="notaFiscal.valorSenat" v-bind="money"
                  class="p-inputtext input-right"></money>
              </span>
            </div>
          </template>
          <template v-else>
            <div class="col-md mb-2">
              <label for="ir">Ir:</label>
              <span class="p-fluid">
                <money id="ir" name="ir" v-model="notaFiscal.valorIr" v-bind="money" class="p-inputtext input-right">
                </money>
              </span>
            </div>
            <div class="col-md mb-2">
              <label for="csll">Csll:</label>
              <span class="p-fluid">
                <money id="csll" name="csll" v-model="notaFiscal.valorCsll" v-bind="money"
                  class="p-inputtext input-right"></money>
              </span>
            </div>
            <div class="col-md mb-2">
              <label for="pis">Pis:</label>
              <span class="p-fluid">
                <money id="pis" name="pis" v-model="notaFiscal.valorPis" v-bind="money" class="p-inputtext input-right">
                </money>
              </span>
            </div>
            <div class="col-md mb-2">
              <label for="cofins">Cofins:</label>
              <span class="p-fluid">
                <money id="cofins" name="cofins" v-model="notaFiscal.valorCofins" v-bind="money"
                  class="p-inputtext input-right"></money>
              </span>
            </div>
          </template>
        </div>
      </div>

      <hr />

      <div class="container">
        <div class="row">
          <div>
            <Button @click="criarCartaCorrecaoNfse()" href="#topo" type="button" label="Criar Carta de Correção"
              class="p-button-primary mr-2 p-button-success" icon="pi pi-check" :disabled="loading" />
          </div>

          <div>
            <Button @click="ocultarDialogCartaCorrecao()" type="button" label="Fechar"
              class="p-button-primary mr-2 p-button-danger" icon="pi pi-times" />
          </div>
        </div>
      </div>
    </Dialog>
  </span>
</template>

<script>
import CartaCorrecaoService from "@/services/nfse/cartacorrecao.service";
import TomadorCadastro from "@/views/TomadorCadastro";
import Pessoa from "@/models/nfse/Pessoa";
import CartaCorrecao from "@/models/nfse/CartaCorrecao";
import NotaFiscal from "@/models/nfse/NotaFiscal";
import money from "@/conf/config.money";
import LoginService from "@/services/acesso/login.service";
import ReportService from "@/services/report.service";

export default {
  name: "CartaCorrecaoNotaFiscal",

  components: {
    TomadorCadastro,
  },

  data() {
    return {
      money: money,
      apresentacao:false,
      cartasCorrecao: [],
      showCartaCorrecao: false,
      showCartaCorrecaoListagem: false,
      notaFiscal: null,
      selectedPessoaPrestador: null,
      selectedPessoaIntermediario: null,
      selectedPessoa: null,
      cartaCorrecao: null,
      currentUser: null,
      observacaoClienteNfse: false
    };
  },

  created() {
    this.apresentacao = (this.$apresentacao ? this.$apresentacao : false);
    this.limparDadosCartaCorrecao();

    this.$root.$on("notaFiscal:cartaCorrecao", (nota) => {
      this.limparDadosCartaCorrecao();

      this.notaFiscal = nota;

      this.pesquisarCartas();


    });
  },

  methods: {
    pesquisarCartas(){
      this.cartasCorrecao = [];
      CartaCorrecaoService.buscarCartasNfse(this.notaFiscal.id)
        .then(
          (response) => {
            this.cartasCorrecao = response.data;
          },
          (error) => {
            console.log(error);
          }
        )
        .then(() => {
          if (this.cartasCorrecao == null || this.cartasCorrecao.length <= 0) {
            this.novaCarta(this.notaFiscal);
          } else {
            this.exibirListagemCarta();
          }
        });
    },
    novaCarta(nota) {
      this.currentUser = LoginService.currentUserValue;
      this.$parent.processando(true);
      CartaCorrecaoService.podeEmitirCarta(nota.id, this.currentUser.usuario.idCliente)
        .then(
          (response) => {
            let retorno = response.data;
            if(retorno != 'OK'){

              if(this.apresentacao){
                CartaCorrecaoService.consultaCartaCorrecaoForaDoPrazo(nota.id);
              }

              this.$root.$emit("alert:error", 'Não é possível emitir uma nova Carta de Correção, pois atingiu o prazo máximo!');
              return;
            }

            this.selectedPessoaPrestador = nota.prestadorDados;
            this.selectedPessoa = nota.tomadorDados;
            this.selectedPessoaIntermediario = nota.intermediarioDados;
            this.cartaCorrecao.idNotaFiscal = this.notaFiscal.id;
            this.cartaCorrecao.notaAvulsa = this.notaFiscal.notaAvulsa;

            this.cartaCorrecao.notaAnterior.idPrestadorDados = this.selectedPessoaPrestador.id;
            this.cartaCorrecao.notaAnterior.idTomadorDados = this.selectedPessoa.id;
            this.cartaCorrecao.notaAnterior.idIntermediarioDados = (this.selectedPessoaIntermediario && this.selectedPessoaIntermediario.id ? this.selectedPessoaIntermediario.id : null);
            this.cartaCorrecao.notaAnterior.discriminacaoServico = this.notaFiscal.discriminacaoServico;
            this.cartaCorrecao.notaAnterior.observacao = this.notaFiscal.observacao;
            this.cartaCorrecao.notaAnterior.valorInss = this.notaFiscal.valorInss;
            this.cartaCorrecao.notaAnterior.valorIr = this.notaFiscal.valorIr;
            this.cartaCorrecao.notaAnterior.valorCsll = this.notaFiscal.valorCsll;
            this.cartaCorrecao.notaAnterior.valorPis = this.notaFiscal.valorPis;
            this.cartaCorrecao.notaAnterior.valorCofins = this.notaFiscal.valorCofins;
            this.cartaCorrecao.notaAnterior.valorIrrf = this.notaFiscal.valorIrrf;
            this.cartaCorrecao.notaAnterior.valorSest = this.notaFiscal.valorSest;
            this.cartaCorrecao.notaAnterior.valorSenat = this.notaFiscal.valorSenat;
            this.cartaCorrecao.notaAnterior.rpsSerie = this.notaFiscal.rpsSerie;
            this.cartaCorrecao.notaAnterior.rpsTipo = this.notaFiscal.rpsTipo;
            this.cartaCorrecao.notaAnterior.rpsNumero = this.notaFiscal.rpsNumero;
            this.observacaoClienteNfse = this.currentUser.configuracao.idBolObservacaoNfse === "S";

            this.exibirDialogCartaCorrecao();
          },
          (error) => {
            const erros = error.response.data;
            this.$parent.erros.push(...erros);
          }
        )
        .then(() => {
          this.$parent.processando(false);
        });


    },

    exibirDialogCartaCorrecao() {
      this.showCartaCorrecao = true;
      this.showCartaCorrecaoListagem = false;
    },

    exibirListagemCarta() {
      this.showCartaCorrecao = false;
      this.showCartaCorrecaoListagem = true;
    },

    ocultarDialogCartaCorrecao() {
      this.limparDadosCartaCorrecao();
      this.showCartaCorrecao = false;
    },

    ocultarDialogCartaCorrecaoListagem() {
      this.limparDadosCartaCorrecao();
      this.showCartaCorrecaoListagem = false;
    },

    editarTomador() {
      this.$root.$emit("notaFiscal:editarTomador");
    },

    editarIntermediario() {
      this.$root.$emit("notaFiscal:editarIntermediario");
    },

    editarPrestador() {
      this.$root.$emit("notaFiscal:editarPrestador");
    },

    criarCartaCorrecaoNfse() {
      this.cartaCorrecao.notaNovo.idPrestadorDados = this.selectedPessoaPrestador.id;
      this.cartaCorrecao.notaNovo.idTomadorDados = this.selectedPessoa.id;
      this.cartaCorrecao.notaNovo.idIntermediarioDados = (this.selectedPessoaIntermediario && this.selectedPessoaIntermediario.id ? this.selectedPessoaIntermediario.id : null);

      this.cartaCorrecao.notaNovo.discriminacaoServico = this.notaFiscal.discriminacaoServico;
      this.cartaCorrecao.notaNovo.observacao = this.notaFiscal.observacao;
      this.cartaCorrecao.notaNovo.valorInss = this.notaFiscal.valorInss;
      this.cartaCorrecao.notaNovo.valorIr = this.notaFiscal.valorIr;
      this.cartaCorrecao.notaNovo.valorCsll = this.notaFiscal.valorCsll;
      this.cartaCorrecao.notaNovo.valorPis = this.notaFiscal.valorPis;
      this.cartaCorrecao.notaNovo.valorCofins = this.notaFiscal.valorCofins;
      this.cartaCorrecao.notaNovo.valorIrrf = this.notaFiscal.valorIrrf;
      this.cartaCorrecao.notaNovo.valorSest = this.notaFiscal.valorSest;
      this.cartaCorrecao.notaNovo.valorSenat = this.notaFiscal.valorSenat;
      this.cartaCorrecao.notaNovo.rpsSerie = this.notaFiscal.rpsSerie;
      this.cartaCorrecao.notaNovo.rpsTipo = this.notaFiscal.rpsTipo;
      this.cartaCorrecao.notaNovo.rpsNumero = this.notaFiscal.rpsNumero;

      this.$parent.processando(true);
      this.$parent.erros = [];

      CartaCorrecaoService.save(this.cartaCorrecao)
        .then(
          (data) => {
            const carta = data.data;

            var mensagem =
              carta.situacao == "E"
                ? "A Carta de Correção foi criada e encaminhada para análise!"
                : "Os dados da Nota Fiscal foram atualizados!";

            this.$root.$emit("alert:success", mensagem);

            if (this.$parent.$options.name == "ConsultaNfse") {
              this.$parent.pesquisar();
            }
          },
          (error) => {
            const erros = error.response.data;
            this.$parent.erros.push(...erros);
          }
        )
        .then(() => {
          this.ocultarDialogCartaCorrecao();
          this.$parent.processando(false);
        });
    },

    cancelarCartaCorrecaoNfse(id) {

      this.$parent.processando(true);
      this.currentUser = LoginService.currentUserValue;
      CartaCorrecaoService.cancelar(id, this.currentUser.usuario.idCliente)
        .then(
          (response) => {
            this.cartaCorrecao = response.data;

            this.$root.$emit("alert:success", 'Carta de Correção Cancelada com Sucesso!');

          },
          (error) => {
            const erro = error.response.data;
            this.$root.$emit("alert:error", erro);
          }
        )
        .then(() => {
          this.$parent.processando(false);
        });
    },

    limparDadosCartaCorrecao() {
      this.selectedPessoaPrestador = new Pessoa();
      this.selectedPessoa = new Pessoa();
      this.selectedPessoaIntermediario = new Pessoa();
      this.notaFiscal = new NotaFiscal();
      this.cartaCorrecao = new CartaCorrecao();
    },
    visualizar(cartaId) {
      this.$parent.processando(true);

      if(this.apresentacao){
        CartaCorrecaoService.consultaCartaCorrecao(cartaId);
      }

      ReportService.imprimir('nfs_carta_correcao_nota', [
        {
          param: "id",
          string: cartaId,
        }

      ])
        .then(
          (data) => {
            console.log(data);
          },
          (error) => {
            this.$root.$emit("alert:warn", "Erro ao exibir a visualização!");
            console.log(error);
          }
        )
        .then(() => {
          this.$parent.processando(false);
        });
    },
  },

  computed: {
    loading() {
      return this.$parent.loading;
    },

    desabilitarEdicaoTomador() {
      return !!this.selectedPessoa.idContribuinte;
    },
  },
};
</script>

<style scoped>
.scrolable-dialog {
  padding-right: 25px;
  width: 90vw;
  max-height: 65vh;
  overflow-y: auto;
  overflow-x: hidden;
}

textarea {
  width: 100%;
  border-radius: 12px;
}
</style>